<template>
  <div>
    <el-upload
      accept=".png,.PNG,.jpg,.JPG,.jpeg"
      class="logoImg"
      list-type="picture-card"
      action
      :one-third="false"
      :auto-upload="true"
      :show-file-list="false"
      :beforeUpload="beforeUpload"
      :http-request="uploadImg"
      :style="{ height: height + 'px', width: width + 'px' }"
    >
      <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，且不超过200MB
      </div>
      <img
        v-if="img_source || img_url"
        :src="img_url ? img_url : img_source"
        class="upload-image"
        ref="image"
      />
      <i
        v-else
        :style="{ lineHeight: height + 'px', fontSize: width / 10 + 'px' }"
        class="el-icon-upload avatar-uploader-icon"
      ></i>
      <div class="mask" v-if="uploadFlag">
        <el-progress
          type="circle"
          :width="100"
          :percentage="uploadPercentage"
          status="success"
          style="margin-top: 15%; z-index: 100"
        ></el-progress>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getOSSAuth_Api } from "../../apis/oss.api";
export default {
  data() {
    return {
      uploadPercentage: 0,
      img_url: null,
      uploadFlag: false,
      img_source: null,
    };
  },
  mounted() {
    if (this.img) {
      this.img_source = this.img;
    }
  },
  watch: {
    img() {
      this.img_source = this.img;
      console.log(this.img_source);
    },
  },
  props: ["img", "width", "height"],
  methods: {
    beforeUpload(file) {
      console.log("img", file);
      const isLimit2 = file.size / 1024 / 1024 < 200;
      if (!isLimit2) {
        this.$global.error(this, "只能上传200MB以内的图片！", null);
        return false;
      } else {
        this.img_url = URL.createObjectURL(file);
        this.img_file = file;
      }
    },

    async uploadImg() {
      if (!this.img_url || !this.img_file) {
        this.$global.error(this, "请选择图片！", null);
        return;
      }
      this.uploadFlag = true;
      let result = await getOSSAuth_Api();
      let str = this.img_file.name.split(".");
      const that = this;
      console.log("au", result);
      if (result) {
        let file_name =
          result.base_path + str[0] + Date.parse(new Date()) + "." + str[1];
        result.oss
          .multipartUpload(file_name, this.img_file, {
            progress: function(p) {
              //p进度条的值
              that.uploadPercentage = Math.floor(p * 100);
            },
          })
          .then((res) => {
            this.uploadFlag = false;
            let upload_url = res.res.requestUrls[0].split("?")[0];
            console.log("result", res.res.requestUrls[0].split("?")[0]);
            this.$global.success(this, "图片上传成功！", null);
            this.$emit("getUploadImage", upload_url);
            this.img_url = null;
          })
          .catch((err) => {
            this.uploadFlag = false;
            console.log(err);
            this.$global.error(this, "图片上传失败！", null);
          });
      } else {
        this.$global.error(this, "服务器错误！", null);
        this.uploadFlag = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-upload {
  position: relative;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    background: $maskbackground;
    top: 0px;
    left: 0px;
    .el-progress {
      position: absolute;
      z-index: 100 !important;
      left: calc(50% - 50px);
      top: calc(50% - 50px);
      margin-top: 0px !important;
      .el-icon-check:before {
        color: #67c23a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/componentSet/uploadImage.vue